import { render, staticRenderFns } from "./DynamicSegments.vue?vue&type=template&id=4651e5b5&scoped=true"
import script from "./DynamicSegments.vue?vue&type=script&lang=js"
export * from "./DynamicSegments.vue?vue&type=script&lang=js"
import style0 from "./DynamicSegments.vue?vue&type=style&index=0&id=4651e5b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651e5b5",
  null
  
)

export default component.exports